import { Box, Container, Grid, Paper, Typography } from '@material-ui/core'
import React, { Component } from 'react'
import scriptLoader from 'react-async-script-loader'
import { connect } from 'react-redux'

import OrderStatus from '../components/common/OrderStatus'
import StickyContainer from '../components/common/StickyContainer'
import HomeDialogs from '../components/home/HomeDialogs'
import HomeSidebar from '../components/home/HomeSidebar'
import HomeRowContainer from '../components/home/HomeRowContainer'
import HomeLocationWidget from '../components/home/HomeLocationWidget'

import HomeSnackbars from '../components/home/HomeSnackbars'
import DeliverySettings from '../components/home/DeliverSettings'
import FeedbackLink from '../components/home/FeedbackLink'
import { MAPS_SCRIPT_URL } from '../components/location-search/LocationSearchBox'
import { loadDeliveryScheduleStart } from '../redux/modules/delivery'
import { addFavoritesForMenusStart, getFavoritesForMenusCount } from '../redux/modules/favorite'
import { selectDateStart } from '../redux/modules/delivery'
import { loadOrderStart } from '../redux/modules/orderDetail'
import {
  selectCurrentLocationWithAddress,
  selectCurrentSavedLocation,
} from '../redux/modules/selectors'
import { pushAnalyticsEvent } from '../util/gtmUtils'
import {
  isSelectedDeliveryDateActive,
  selectDeliveries,
} from '../redux/selectors/deliverySelectors'
import HomeDeliveries from '../components/home/HomeDeliveries'
import LayoutInnerPage from '../layouts/LayoutInnerPage'
import { getDayName } from '../util/dateUtils'

class Home extends Component {
  async componentDidMount() {
    let {
      match: {
        params: { locationId },
      },
    } = this.props
    const { isAuthenticated } = this.props
    locationId = Number(locationId)

    this.fetchDeliveries(locationId)
    if (isAuthenticated) {
      this.fetchPageData(locationId)
    }
    pushAnalyticsEvent('Ordering', 'View Deliveries', undefined, locationId)
  }

  componentDidUpdate(prevProps) {
    const { isAuthenticated } = this.props
    let {
      match: {
        params: { locationId = 0 },
      },
    } = this.props
    locationId = Number(locationId)
    if (Number(prevProps.match.params.locationId) !== locationId) {
      this.fetchDeliveries(locationId)
      this.fetchPageData(locationId, true)
    }
    if (prevProps.isAuthenticated === false && isAuthenticated === true) {
      this.fetchPageData(locationId)
    }
    if (this.props.deliveries && this.props.deliveries !== prevProps.deliveries) {
      this.fetchFavoritesForMenus()
    }
  }

  fetchDeliveries = locationId => {
    const { loadDeliveryScheduleStart, selectedDate } = this.props
    loadDeliveryScheduleStart(locationId, selectedDate)
  }

  fetchFavoritesForMenus = async () => {
    const { addFavoritesForMenusStart, deliveries, isAuthenticated } = this.props
    const menuIds = deliveries.map(d => d.menuId)
    if (menuIds.length > 0 && isAuthenticated) {
      const result = await getFavoritesForMenusCount(menuIds)
      addFavoritesForMenusStart(result)
    }
  }

  fetchPageData = currentLocationId => {
    const { isAuthenticated, loadOrderStart, selectedDate } = this.props
    const locationId = currentLocationId || Number(this.props.match.params.locationId)
    if (isAuthenticated) {
      loadOrderStart(selectedDate, locationId)
    }
  }

  render() {
    const {
      activationDate,
      selectDateStart,
      currentSavedLocation,
      deliveries,
      errorLoading,
      isAuthenticated,
      isLoadingDeliveries,
      isScriptLoadSucceed,
      isScriptLoaded,
      isSelectedDayActive,
      isWebpSupported,
      location,
      orders,
      selectedDate,
    } = this.props
    let {
      friendHasOrdered,
      match: {
        params: { locationId },
      },
    } = this.props
    locationId = Number(locationId)
    const hasOrders = orders && orders.length > 0
    const showManageOrder = hasOrders && !isLoadingDeliveries
    return (
      <>
        <LayoutInnerPage
          HeaderComponent={
            <>
              <HomeRowContainer rowTitle="Location" hideForDesktop loading={isLoadingDeliveries}>
                <HomeLocationWidget />
              </HomeRowContainer>
              <Container maxWidth="lg">
                <DeliverySettings
                  loading={isLoadingDeliveries}
                  selectDateStart={selectDateStart}
                  isScriptLoaded={isScriptLoaded}
                  isScriptLoadSucceed={isScriptLoadSucceed}
                  locationId={locationId}
                  name={
                    currentSavedLocation?.name ||
                    currentSavedLocation?.deliveryLocationName ||
                    location?.deliveryLocationName
                  }
                  orderCount={orders?.length}
                  selectedDate={selectedDate}
                />
              </Container>

              {showManageOrder && (
                <>
                  <Box marginTop={3} marginBottom={5}>
                    <Paper color="secondary" square variant="outlined">
                      <Box paddingY={4}>
                        <Container className="container">
                          <Grid container justifyContent="center">
                            <Grid item md={8} xs={12}>
                              <OrderStatus locationId={locationId} />
                            </Grid>
                          </Grid>
                        </Container>
                      </Box>
                    </Paper>
                  </Box>
                  <Container maxWidth="lg">
                    <Typography component="h2" gutterBottom variant="h6">
                      More options delivering {getDayName(selectedDate)}
                    </Typography>
                  </Container>
                </>
              )}
            </>
          }
          MainComponent={
            <>
              <HomeDeliveries
                isAuthenticated={isAuthenticated}
                deliveries={deliveries}
                loading={isLoadingDeliveries}
                selectedDate={selectedDate}
                hasOrders={hasOrders}
                errorLoading={errorLoading}
                friendHasOrdered={friendHasOrdered}
                isSelectedDayActive={isSelectedDayActive}
                isWebpSupported={isWebpSupported}
                locationId={locationId}
                activationDate={activationDate}
                selectDateStart={selectDateStart}
              />
              {!isLoadingDeliveries && (
                <Box className="center-xs" marginTop={4}>
                  <FeedbackLink />
                </Box>
              )}
            </>
          }
          SidebarComponent={
            <StickyContainer stickyStyle={{ paddingTop: '50px' }} topOffset={-80}>
              {isAuthenticated && <HomeSidebar />}
              {!isAuthenticated && <HomeLocationWidget />}
            </StickyContainer>
          }
          headerContainerMaxWidth={false}
          hideSidebar="sm"
        />
        <HomeDialogs
          locationId={locationId}
          isScriptLoaded={isScriptLoaded}
          isScriptLoadSucceed={isScriptLoadSucceed}
        />
        <HomeSnackbars />
      </>
    )
  }
}

const mapStateToProps = state => {
  const deliveries = selectDeliveries(state)
  const { isLoadingDeliveries, selectedDate, errorLoading } = state.delivery
  const { isAuthenticated } = state.user
  const location = selectCurrentLocationWithAddress(state)
  const { location: { activationDate } = {} } = state.location
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const { loading, orders } = state.orderDetail
  const { isWebpSupported } = state.browser
  const currentSavedLocation = selectCurrentSavedLocation(state)

  return {
    activationDate,
    currentSavedLocation,
    deliveries,
    errorLoading,
    isAuthenticated,
    isLoadingDeliveries,
    isOrdersLoading: loading,
    isSelectedDayActive,
    isWebpSupported,
    location,
    orders,
    selectedDate,
  }
}

const mapDispatchToProps = {
  addFavoritesForMenusStart,
  selectDateStart,
  loadDeliveryScheduleStart,
  loadOrderStart,
}

export default scriptLoader(MAPS_SCRIPT_URL)(connect(mapStateToProps, mapDispatchToProps)(Home))
